import { Loading } from "../Loading"

export function DocsLoadingState() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loading />
    </div>
  )
}
